const KEY = "un_privacy_choice_v1";
export const getPrivacyChoice = () => {
  try { return localStorage.getItem(KEY); } catch { return null; }
};
export const setPrivacyChoice = (choice) => {
  try { localStorage.setItem(KEY, choice); } catch {}
  window.dispatchEvent(new CustomEvent("un-privacy-choice", { detail: choice }));
};
export const analyticsAllowed = () => getPrivacyChoice() === "optional";
